import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ImportarCartaoService {

  constructor(
    private http: HttpService,
  ) { }

  buscarCard(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/card-import', data, successHandle, errorHandle);

  }

  salveCard(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doPut('/card-import', data, successHandle, errorHandle);

  }

}
